import { EditorV3Style, EditorV3Styles } from "@azu-business/editor-v3";
import { eStyleTlfType, StyleReadDto } from "functions/api/styles/getAllStyles";

type ExtendedEditorV3Style = EditorV3Style & {
  [key: string]: string;
};

/**
 * Converts style definitions from the backend format to EditorV3 styles.
 * Filters styles by TLF type and transforms style attributes into key-value pairs.
 *
 * @param styles - The style definitions to convert to EditorV3 format
 * @param type - The TLF (Table, Listing, or Figure) type to filter styles for
 * @returns An EditorV3Styles object mapping style names to their attribute key-value pairs
 */
export const stylesToV3 = (styles: StyleReadDto[], type: eStyleTlfType): EditorV3Styles => {
  const customStyleMap: EditorV3Styles = {};
  const filteredStyles = styles.filter((s) => s.tlfItemType === type && s.name !== "NoStyle");
  filteredStyles.forEach((s) => {
    customStyleMap[s.name] = {};
    const thisStyle = customStyleMap[s.name] as ExtendedEditorV3Style;
    s.styleAttributes.forEach((a) => {
      thisStyle[a.key as string] = a.value;
    });
  });
  return customStyleMap;
};
